'use strict';

import React from 'react';
import RacePrognosisForm from "../../src/RacePrognosisForm";

document.addEventListener('DOMContentLoaded', () => {

  const body = $("body");
  I18n.locale = body.data("locale");
  I18n.defaultLocale = body.data("locale-default");
  I18n.fallbacks = true;

  let form;
  const race_prognosis_form = $("#new_prognosis_form");
  if (race_prognosis_form.length) {
    const embed_popup = $("#embedPopup");
    form = new RacePrognosisForm(race_prognosis_form, embed_popup);
    form.init();
  }

});
